import React from 'react';
import Button from '../../core/Button';
import Grid from '../../core/Grid';
import Text from '../../core/Text';
import Layout, { withLayout } from '../Layout';
import Tokens from '../../core/styles/Tokens';
import { createStyles, withStyles } from '../../core/styles/withStyles';
import Constants from '../../../helpers/Constants';
import LogData from '../../../helpers/LogData';
import Redirect from '../../../helpers/Redirect';
import LayoutActions from '../../../flux/actions/LayoutActions';
import LayoutStore from '../../../flux/stores/LayoutStore';
const styles = (theme) => createStyles({
    errorImage: {
        height: 'auto',
        width: Tokens.widthFluid
    },
    errorImageContainer: {
        [theme.breakpoints.down('sm')]: {
            marginTop: Tokens.spacing70
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: Tokens.spacing50
        },
        marginTop: Tokens.spacing80
    }
});
class SpecifcError extends React.Component {
    constructor(props) {
        super(props);
        this.hideAllLoaders = () => {
            this.setState({
                isLoading: false
            });
        };
        this.resolveLayoutReady = () => {
            try {
                const { resources } = this.state;
                if (resources) {
                    document.title = resources.lblPageTitle;
                    this.setState({
                        isAuthenticated: LayoutStore.getIsAuthenticated(),
                        isLoading: false
                    }, LayoutActions.hidePageLoader);
                }
                else {
                    this.logError(LogData.noResources(this.resolveLayoutReady.name));
                }
            }
            catch (e) {
                this.logError(LogData.fromException(this.resolveLayoutReady.name, e));
            }
        };
        this.onLayoutReady = () => {
            const ready = LayoutStore.getLayoutReady();
            const resources = LayoutStore.getResources();
            if (ready) {
                this.setState({
                    resources: resources
                }, this.resolveLayoutReady);
            }
            else {
                this.logError(LogData.layoutNoReady(this.onLayoutReady.name));
                this.redirectError(500);
            }
        };
        this.idModule = 'Errors';
        const hdnIdPage = document.getElementById('hdnIdPage');
        if (hdnIdPage && hdnIdPage.value) {
            this.idPage = hdnIdPage.value;
            hdnIdPage.remove();
        }
        else {
            this.idPage = '';
            Redirect.toError();
        }
        this.state = this.getInitialState();
        LayoutStore.addLayoutReadyListener(this.onLayoutReady);
    }
    getInitialState() {
        let isLoading = true;
        let resources;
        if (this.state) {
            isLoading = this.state.isLoading;
            resources = this.state.resources;
        }
        return {
            isAuthenticated: false,
            isLoading: isLoading,
            resources: resources
        };
    }
    redirectToHome() {
        Redirect.toHome();
    }
    logError(logData) {
        this.hideAllLoaders();
        LayoutActions.setLogData(logData);
    }
    redirectError(code) {
        this.hideAllLoaders();
        LayoutActions.setRedirectCode(code);
    }
    componentWillUnmount() {
        LayoutStore.removeLayoutReadyListener(this.onLayoutReady);
    }
    render() {
        const { classes, homeButtonRequireAuth } = this.props;
        const { isAuthenticated, isLoading, resources } = this.state;
        let contentPage;
        if (resources && !isLoading) {
            let imgSrc = `${Constants.imagesCDN}/illustrations/large/500.png`;
            switch (this.idPage) {
                case 'Error400':
                    imgSrc = `${Constants.imagesCDN}/illustrations/large/400.png`;
                    break;
                case 'Error401':
                    imgSrc = `${Constants.imagesCDN}/illustrations/large/401.png`;
                    break;
                case 'Error403':
                case 'ExpiredInvitation':
                case 'InvalidInvitation':
                    imgSrc = `${Constants.imagesCDN}/illustrations/large/403.png`;
                    break;
                case 'Error404':
                    imgSrc = `${Constants.imagesCDN}/illustrations/large/404.png`;
                    break;
                case 'Error500':
                    imgSrc = `${Constants.imagesCDN}/illustrations/large/500.png`;
                    break;
                case 'Error503':
                    imgSrc = `${Constants.imagesCDN}/illustrations/large/503.png`;
                    break;
            }
            contentPage = (React.createElement(Grid, { container: true, spacing: 3 },
                React.createElement(Grid, { item: true, xs: true },
                    React.createElement(Grid, { container: true, justify: "center" },
                        React.createElement(Grid, { item: true, className: classes.errorImageContainer },
                            React.createElement("img", { className: classes.errorImage, alt: resources.lblTitle, src: imgSrc }))),
                    React.createElement(Grid, { container: true, spacing: 3, direction: "column", alignItems: "center" },
                        React.createElement(Grid, { item: true },
                            React.createElement(Text, { align: "center", size: "h1" }, resources.lblTitle)),
                        React.createElement(Grid, { item: true },
                            React.createElement(Text, { align: "center", size: "h4" }, resources.lblText)),
                        Boolean(!homeButtonRequireAuth
                            || (homeButtonRequireAuth && (this.idPage !== 'Error401' || isAuthenticated))) && (React.createElement(Grid, { item: true },
                            React.createElement(Button, { id: "btnGoHome", onClick: this.redirectToHome }, resources.lblGoToHome)))))));
        }
        return (React.createElement(Layout, { idModule: this.idModule, idPage: this.idPage }, contentPage));
    }
}
const SpecifcErrorWithLayout = withLayout(withStyles(styles)(SpecifcError));
export default SpecifcErrorWithLayout;
